import { FC } from "react";
import { useParams } from "react-router-dom";

import { useCrudNavigate } from "@ryde/redux";
import { DrawerType, EditFormMode } from "@ryde/shared";

import { CourseEditFormDrawer } from "../../drawers";

interface ICourseEdit {
  isAddRoute?: boolean;
}

export const CourseEdit: FC<ICourseEdit> = ({ isAddRoute }) => {
  const { id } = useParams<{ id: string }>();
  const { navigateToList } = useCrudNavigate("course");
  const idOpen = Number(id) && !isAddRoute ? Number(id) : undefined;
  const idCopyFrom = Number(id) && isAddRoute ? Number(id) : undefined;
  return (
    <CourseEditFormDrawer
      type={DrawerType.CourseEditForm}
      mode={EditFormMode.CrudRoute}
      onCloseDrawer={navigateToList}
      id={idOpen}
      idCopyFrom={idCopyFrom}
    />
  );
};
